module.exports = __webpack_public_path__ + "static/img/logo5.45cd897.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/logo5.png
// module id = YMnU
// module chunks = 1